// @import "../../styles/colors";

.root {
  display: flex;
  flex-flow: column wrap;
  align-items: space-around;
  justify-content: center;
  align-items: center;
  height: 50vh;
  max-width: 100vw;
}

.copy {
  margin: 0.2em 0;
  text-align: center;
  z-index: 51;
  margin-left: -3.5em;
}

.barTop {
  margin-left: 0.8em;
  width: 20em;
  height: 1.5em;
  border-top: 0.45em solid #ff00ff;
  border-bottom: 0.45em solid #ff00ff;
  transform: skew(-45deg);
}

.barBottom {
  width: 20em;
  height: 1.5em;
  border-top: 0.45em solid #ff00ff;
  border-bottom: 0.45em solid #ff00ff;
  transform: skew(45deg);
  margin-left: 0;
  margin-right: 0.8em;
}

.letter {
  display: inline-block;
}
